import React from "react";
import Icons from "../../../../../../Config/Images";
import "./DeleteModal.css"; // Import a new CSS file for any custom styling

const DeleteModal = ({ onClose, onDelete }) => {
  return (
    <div className="delete-modal-overlay">
      <div className="delete-modal-content">
        <img src={Icons.trashIcon} alt="Delete Icon"/>
        <h4 className="delete-modal-title">
          Are you sure you want to <br /> delete this item?
        </h4>

        <div className="delete-modal-buttons">
          <button onClick={onClose} className="delete-no-button">
            Cancel
          </button>
          <button onClick={onDelete} className="delete-yes-button">
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteModal;
